import React, { useContext, useEffect, useState } from 'react';
import { withTranslation } from "react-i18next";
import { RegulationContext } from "../../../App";
import WorldMap from '../../../components/WorldMap/WorldMap';
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import CompanyService from "../../../core/service/CompanyService";
import Utils from "../../../core/utilities/Utils";
import RiskPriority from "../../SubscriberSupplierAdmin/RiskPriority/RiskPriority";
import TotalSuppliers from "../../SubscriberSupplierAdmin/TotalSuppliers/TotalSuppliers";

const SupplierRiskCountCard = ({ t, selYear }) => {

	const lsData = JSON.parse(localStorage.getItem("authority"));
	const companyId = lsData.profile.company.id;
	const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
	const [totalSupplier, setTotalSupplier] = useState("");
	const [riskPriority, setRiskPriority] = useState([]);
	const annualYear = selYear;
	const glbRegulationId = glbRegulation?.id ?? '';
	const [chartData, setChartData] = useState([]);

	useEffect(() => {
		if (glbRegulationId) {
			const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
			getRiskPriority(month);
			getSupplierStatusCountryReport(month);
		}
	}, [glbRegulationId, annualYear]);


	const getRiskPriority = (month) => {
		if (glbRegulationId) {
			CompanyService.getSuppliersCountByRegulation(
				companyId,
				glbRegulationId,
				annualYear + '-' + month + '-01'
			).then((response) => {
				setTotalSupplier(response.data.totalSuppliers);
				setRiskPriority(response.data);
			}).catch((error) => {
				console.log("err", error);
			});
		}
	};

	const getSupplierStatusCountryReport = (month) => {
		CompanyDashboardService.getSupplierStatusCountryReport(
			companyId,
			glbRegulationId,
			annualYear + '-' + month + '-01',
		).then((response) => {
			setChartData(response.data);
		}).catch((error) => {
			console.log("err", error);
		});
	};


	return (
		<div className="card SC-Supplier_totalCard_02">
			<div className="SC-Supplier_totalCard_02-head">
				<strong>{t("SupplierRisk.label")} </strong>
			</div>
			<div className="SC-Supplier_totalCard_02-body">
				<div className="row m-0">
					
					<div className='Supplier_Risk_WorldMap col-lg-8 p-0' data-tip="">
						<WorldMap chartData={chartData} />
					</div>
					<div className='col-lg-4 p-0'>
						<TotalSuppliers totalSupplier={totalSupplier} isDashboardView={true} />
						<RiskPriority riskPriority={riskPriority} isDashboardView={true} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default withTranslation()(SupplierRiskCountCard);